import {
  Drawer,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  IconButton,
  useMediaQuery,
  Divider,
  Box,
  ListItem,
} from "@mui/material";
import { Menu as MenuIcon } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";
import { FaUser } from "react-icons/fa";
import { RiUserStarFill } from "react-icons/ri";
import { GoStarFill } from "react-icons/go";
import { useLocation, useNavigate } from "react-router-dom";
import { ImExit } from "react-icons/im";
import { LuArchiveRestore } from "react-icons/lu";
import { useState } from "react";
import LogoutModal from "../Models/LogoutModel";
import { FaFileInvoiceDollar } from "react-icons/fa6";
import { BsExclamationCircleFill } from "react-icons/bs";
import { TbReportAnalytics } from "react-icons/tb";
import { MdCall } from "react-icons/md";

const drawerWidth = 240;

export default function Sidebar({ mobileOpen, onClose}) {
  const [openLogout, setOpenlogout] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const location = useLocation();
  const navigate = useNavigate();

  const menuItems = [
    { label: "Users", icon: <FaUser size={20} />, path: "/users" },
    { label: "Expert Users", icon: <RiUserStarFill size={22} />, path: "/users/experts" },
    { label: "Feedbacks", icon: <GoStarFill size={22} />, path: "/feedbacks" },
    { label: "Recycle", icon: <LuArchiveRestore size={22} />, path: "/recycle" },
    { label: "Withdrawal Requests", icon: <FaFileInvoiceDollar size={22} />, path: "/withdrawal-requests" },
    { label: "Reports", icon: <BsExclamationCircleFill size={22} />, path: "/reports" },
    { label: "Call History", icon: <MdCall size={26} />, path: "/call-history" }
  ];

  const handlelogout = () => {
    setOpenlogout(true)
  }
  return (
    <>
      <Drawer
        variant={isMobile ? "temporary" : "permanent"}
        open={!isMobile || mobileOpen}
        onClose={onClose}
        ModalProps={{ keepMounted: true }}
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            boxSizing: "border-box",
            ...(isMobile ? {} : { mt: 8 }),
            background: "linear-gradient(to right, #131313, #3B3B3B)",
            color: "#e5e7eb",
            display: "flex",
            flexDirection: "column",
          },
        }}
      >
        {isMobile && (
          <IconButton onClick={onClose} sx={{ m: 1 }}>
            <MenuIcon />
          </IconButton>
        )}

        <Box sx={{ flex: 1 }}>
          <List>
            {menuItems.map((item) => {
              const currentPath = location.pathname === "/" ? "/users" : location.pathname;
              const isActive = currentPath === item.path;
              return (
                <ListItemButton
                  key={item.label}
                  disableRipple
                  onClick={() => {
                    navigate(item.path);
                    if (isMobile) onClose();
                  }}
                   className="group"
                >
                  <ListItemIcon sx={{ minWidth: 40 }}>
                    <span
                      className={`${isActive ? "text-[#F1580C]" : "text-[#FFFFFF8A] group-hover:text-[#FFF]"
                        }`}
                    >
                      {item.icon}
                    </span>
                  </ListItemIcon>
                  <ListItemText
                    primary={item.label}
                    className={`${isActive ? "text-[#F1580C]" : "text-[#FFFFFF8A] group-hover:text-[#FFF]"
                      }`}
                  />
                </ListItemButton>
              );
            })}
          </List>
        </Box>

        <Divider sx={{ borderColor: "#656565" }} />

        <Box sx={{ mt: "auto", mb: { sm: 8 } }}>
          <List>
            <ListItem
              button
              sx={{ pl: 2 }}
              className={"text-[#FFFFFF8A] cursor-pointer"}
              onClick={() => handlelogout()}
            >
              <ListItemIcon>
                <ImExit color="#FFFFFF8A" size={25} />
              </ListItemIcon>
              <ListItemText sx={{ ml: "-20px" }} primary={"Logout"} />
            </ListItem>
          </List>
        </Box>
      </Drawer>

      <LogoutModal
        openLogout={openLogout}
        setOpenlogout={setOpenlogout}
      />
    </>
  );
}
